import React, { memo, useState } from 'react';

import {
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Typography,
} from 'antd';

import { RESTAddOrg } from 'utils/RESTApi';

const OrganizationModal = ({
  isOrganizationModalOpen,
  setIsOrganizationModalOpen,
  fetchOrganizations,
  getAllUsersCount,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    setIsOrganizationModalOpen(false);
  };

  const addOrganization = async () => {
    setLoading(true);
    try {
      const formValues = form.getFieldsValue();
      const userEmail = formValues?.email?.toLowerCase();
      if (
        !formValues.orgname ||
        !formValues.firstname ||
        !formValues.lastname ||
        !userEmail ||
        !formValues.role
      ) {
        message.error('Please fill in all the required fields');
        setLoading(false);
      } else {
        let inputData = {
          organization: formValues.orgname,
          firstname: formValues.firstname,
          lastname: formValues.lastname,
          email: userEmail,
          role: formValues.role,
        };

        let res = await RESTAddOrg(inputData);
        await fetchOrganizations();
        await getAllUsersCount();
        setLoading(false);
        if (res.status === 405) {
          message.error('User already exists in the system');
        } else {
          message.success('Organiation created and sent email successfully.');
        }
        setIsOrganizationModalOpen(false);
      }
    } catch (err) {
      setLoading(false);
      throw err;
    }
  };

  return (
    <>
      <Modal
        open={isOrganizationModalOpen}
        onCancel={handleCancel}
        onOk={addOrganization}
        cancelText="Cancel"
        okText="Add"
        width={600}
        confirmLoading={loading}
      >
        <Typography.Title level={3}>Add an Organization</Typography.Title>
        <Form
          requiredMark={false}
          layout="vertical"
          form={form}
          className="org-form"
        >
          <Row>
            <Col span={16}>
              <Form.Item
                label="Organization name"
                name="orgname"
                rules={[
                  {
                    required: true,
                    message: 'Please enter organization name',
                  },
                ]}
              >
                <Input placeholder="Enter organization name" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Typography.Title level={5}>Add User</Typography.Title>
          </Row>
          <Row gutter={10}>
            <Col span={12}>
              <Form.Item
                label="First Name"
                name="firstname"
                rules={[
                  {
                    required: true,
                    message: 'Please enter first name',
                  },
                ]}
              >
                <Input placeholder="Enter first name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Last Name"
                name="lastname"
                rules={[
                  {
                    required: true,
                    message: 'Please enter last name',
                  },
                ]}
              >
                <Input placeholder="Enter last name" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col span={12}>
              <Form.Item
                label="Email ID"
                name="email"
                rules={[
                  {
                    required: true,
                    message: 'Please enter email',
                  },
                ]}
              >
                <Input placeholder="Enter email id" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Role"
                name="role"
                rules={[
                  {
                    required: true,
                    message: 'Please select role',
                  },
                ]}
              >
                <Select placeholder="Select role">
                  <Select.Option value={'ADMIN'}>Admin</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default memo(OrganizationModal);

